module.exports = __webpack_public_path__ + "static/media/main_tit.dd999b2c.png";